import { Box, Button, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "../../../assets/SVG/closeIcon";
import FlagIcon from "../../../assets/SVG/flagIcon";
import AddDrugInAreaPop from "./addDrugInAreaPop";
import DeleteIcon from "../../../assets/SVG/deleteIcon";
import ArchiveDrugsPop from "./archiveDrugsPop";

export default function SelectionsTableDrug({
  showAddDrugToAreaFrom,
  setShowAddDrugToAreaFrom,
  selection,
  setSelection,
  equipment,
  notGroup,
}) {
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [dataDrugSelect, setDataDrugSelect] = useState([]);
  useEffect(() => {
    if (selection) {
      if (equipment) {
        setDataDrugSelect(
          selection?.map((x) => {
            return { equipmentId: x?.data?.id };
          }),
        );
      } else {
        setDataDrugSelect(
          selection?.map((x) => {
            return { drugId: x?.data?.id };
          }),
        );
      }
    }
  }, [selection]);
  return (
    <>
      {showAddDrugToAreaFrom && (
        <AddDrugInAreaPop
          setDataDrugSelect={setDataDrugSelect}
          dataDrugSelect={dataDrugSelect}
          equipment={equipment}
          notGroup={notGroup}
        />
      )}
      <ArchiveDrugsPop
        onArchive={() => window.location.reload()}
        selectedDrugs={dataDrugSelect}
        open={openArchiveDialog}
        setOpen={setOpenArchiveDialog}
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{ boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)" }}
          bgcolor="#9091A6"
          width="65%"
          height="60px"
          borderRadius="30px"
          position={"fixed"}
          px={"20px"}
          bottom="20px"
          display="flex"
          justifyContent={"space-between"}
          alignItems="center"
        >
          <Box display="flex" alignItems="center" gap="20px">
            <IconButton onClick={() => setSelection([])}>
              <CloseIcon size="1.8" color="white" />
            </IconButton>
            <Typography
              fontFamily={"Vazirmatn"}
              color="white"
              fontSize="18px"
            >{`${selection?.length} مورد انتخاب شده`}</Typography>
          </Box>
          {showAddDrugToAreaFrom && (
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                setSelection([]);
                setShowAddDrugToAreaFrom(false);
              }}
            >
              انصراف
            </Button>
          )}
          {!showAddDrugToAreaFrom && (
            <Box display="flex">
              <Box
                bgcolor="#686A97"
                width="150px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setShowAddDrugToAreaFrom(true);
                }}
              >
                <FlagIcon color="white" />
                {"افزودن به اردو"}
              </Box>
              <Box
                bgcolor="var(--emr-red)"
                width="150px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                onClick={() => setOpenArchiveDialog(true)}
              >
                <DeleteIcon color="white" />
                {"آرشیو کردن دارو"}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
